module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Book-0aa18bbf636d33966235d233e87e2b35.eot";